(function noaaSearchScript($, Drupal) {
  Drupal.behaviors.noaaSearch = {
    attach(context) {
      $('.pager__item--previous').hide();
      $('.pager__item--next').hide();
//       const urlParams = new URLSearchParams(window.location.search);
//       const queryParam = urlParams.get('oq');
//       $('.noaa-search .webdam-image-caption-container').addClass('hidden');
//       $('.noaa-search .media-thumbnail').each((index, element) => {
//         const media = $(element).css('background-image');
//         if (media.indexOf('amazonaws') === -1) {
//           $(element).addClass('hidden');
//         }
//         else {
//           $(element).closest('.views-field').next('.views-field').addClass('hidden');
//         }
//       });
//       $('.media-tile').each((index) => {
//         if ($('.media-tile').attr('data-media-url') === '/') {
//           $('.media-tile').hide();
//         }
//       });
//       // Parse param.
//       const terms = queryParam.split(' ');
//       // Identify the field with data by class.
//       const elements = document.getElementsByClassName('summery-text');
//       if ($('#tile_0').attr('data-media-id').length < 0) {
//         $('#tile_0').hide();
//       }
//       // Loop through the items div rows.
//       for (let i = 0; i < elements.length; i++) {
//         terms.forEach((item) => {
//           const data = elements[i].innerHTML;
//           // Set case insensitive using regex.
//           const re = new RegExp(item, 'i');
//           const match = data.match(re);

//           // Run match.
//           if (match) {
//             const highlight = `<highlight>${match}</highlight>`;
//             const res = data.replace(match, highlight);

//             // Replace
//             elements[i].innerHTML = res;
//           }

//           if ($('img')[i].attr('src').indexOf('webdamdb')) {
//             $('.media-thumbnail').hide();
//           }
//         });
//       }
    },
  };
}(jQuery, Drupal));
